var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u65F6\u95F4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-223.000000, -1462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u65F6\\u95F4",
    transform: "translate(223.000000, 1462.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1 C11.8641657,1.00440864 14.9955914,4.13583434 15,8 C15,11.8659932 11.8659932,15 8,15 C4.13400675,15 1,11.8659932 1,8 C1,4.13400675 4.13400675,1 8,1 Z M8,2.16599999 C4.77797077,2.16599999 2.16599999,4.77797077 2.16599999,8 C2.16599999,11.2220292 4.77797077,13.834 8,13.834 C11.2206584,13.8306928 13.8306928,11.2206584 13.834,8 C13.834,4.77797077 11.2220292,2.16599999 8,2.16599999 Z M7.888,4.04658824 C8.26322876,4.04658824 8.56741176,4.35077125 8.56741176,4.726 L8.56638235,8.06747059 L10.657055,9.27588992 C10.9972173,9.44946108 11.1345521,9.86261003 10.9664072,10.2044576 C10.8885758,10.3618168 10.7480035,10.4790661 10.5792316,10.5273951 C10.4104596,10.575724 10.2291329,10.5506528 10.0809194,10.4590231 L7.93278859,9.15496594 C7.82573974,9.10509091 7.72958999,9.03745244 7.68557328,8.98217135 C7.3938908,8.8160231 7.20858824,8.63882752 7.20858824,8.4 L7.20858824,4.726 C7.20858824,4.35077125 7.51277124,4.04658824 7.888,4.04658824 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#575C62",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/时间.b724ed8de270bc57c7ccaaaed0827996.svg";
export { ForwardRef as ReactComponent };